export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-17-4501b9d0f5d127be7ec7fdfb72bbcfed.png";